module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "investors"
  }, [_c('nav', {
    staticClass: "sub-menu"
  }, [_c('div', {
    staticClass: "centered"
  }, [_vm._l((_vm.investorPages), function(item) {
    return _c('span', {
      key: item.id,
      staticClass: "nav-elem",
      on: {
        "click": _vm.handleGetInvestorPage
      }
    }, [_c('router-link', {
      key: item.id,
      class: !_vm.$route.params.id && item.id === _vm.investorPages[0].id ? 'is-active' : '',
      attrs: {
        "to": {
          name: 'Investor',
          params: {
            id: item.id
          }
        },
        "active-class": "is-active"
      }
    }, [_vm._v("\n          " + _vm._s(item.title) + "\n        ")])], 1)
  }), _vm._v(" "), (_vm.investorPages && _vm.investorPages.length < 2) ? _c('span', {
    staticClass: "button-wrapper centered nav-elem",
    on: {
      "click": _vm.addInvestorPage
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Страница\n      ")]) : _vm._e()], 2)]), _vm._v(" "), (_vm.investorPage) ? _c('Investor') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d01fde0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BondedLoan/Investors.vue
// module id = 960
// module chunks = 0